import { Card, Image } from "react-bootstrap";
import PropTypes from "prop-types";
import classNames from "classnames";

import DependantImage from "../../../assets/icons/dependent.png";
import DisconnectedImage from "../../../assets/icons/disconnected.png";
import IndependentImage from "../../../assets/icons/independent.png";
import InterdependentImage from "../../../assets/icons/interdependent.png";
import { useUser } from "../../UserContext";

import { relationshipStrategyToField } from "../helpers/reportHelpers";

const strategyDetails = {
	dependent: {
		icon: DependantImage,
		title: "Dependent Relationship Strategy (LSHO - Low Trust of Self & High Trust of Other)"
	},
	disconnected: {
		icon: DisconnectedImage,
		title: "Disconnected Relationship Strategy (LSLO - Low Trust of Self & Other)"
	},
	independent: {
		icon: IndependentImage,
		title: "Independent Relationship Strategy (HSLO - High Trust of Self & Low Trust of Other)"
	},
	interdependent: {
		icon: InterdependentImage,
		title: "Interdependent Relationship Strategy (HSO - High Trust of Self & Other)"
	}
}

const RelationshipPercentile = ({ chart, strategy }) => {
	const { respondent } = useUser();

	const value = respondent?.weqProfile?.stats?.[`${relationshipStrategyToField[strategy]}_dist`];
	const percentile = respondent?.weqProfile?.percentiles?.[`${relationshipStrategyToField[strategy]}_dist`];

	return (
		<Card body className="bg-white mb-3 position-sticky top-0">
			{chart ? <h3>{strategyDetails[strategy].title}</h3> : null}
			<div className="d-flex gap-2">
				<Image
					alt={strategyDetails[strategy].title}
					className="emotion-percentile-icon"
					height="70"
					src={strategyDetails[strategy].icon}
					width="70"
				/>
				<div className={classNames("flex-fill emotion-percentile d-flex justify-content-center flex-column")}>
					<div className="d-flex justify-content-between w-100 align-items-center">
						<strong className="text-capitalize">
							<span className={`rounded-circle d-inline-block me-1 bg-eqqo-${strategy}`} height="10" style={{ height: "10px", width: "10px" }} width="10" />
							{strategy}
						</strong>
						{ chart
							? <span>{value?.toFixed(2)} | {percentile?.toFixed(2)}% Percentile</span>
							: (
								<div className="d-flex text-center">
									<div className="score-container pe-2 border-end">
										<div className="fw-bold">
											{value?.toFixed(2)}
										</div>
										<div className="text-secondary fs-14">
											Score
										</div>
									</div>
									<div className="score-container ps-2">
										<div className="fw-bold">
											{percentile?.toFixed(2)}
										</div>
										<div className="text-secondary fs-14">
											Percentile
										</div>
									</div>
								</div>
							)}
					</div>
					{chart
						? (
							<div className="emotion-percentile-bar w-100 bg-eqqo-pale-gray rounded-1 position-relative mt-2">
								<div className={`emotion-percentile-progress rounded-1 py-1 h-100 bg-eqqo-${strategy}`} style={{ width: `${percentile}%` }} />
							</div>
						) : null}
				</div>
			</div>
		</Card>
	);
}

RelationshipPercentile.propTypes = {
	chart: PropTypes.bool,
	strategy: PropTypes.string.isRequired
};

RelationshipPercentile.defaultProps = {
	chart: false
};

export default RelationshipPercentile;
